import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

import { updateLeadFields } from 'bundles/project/actions/leads';
import { SAVE_ERROR_TEXT, saveErrorText } from 'bundles/leads/helper/save_error_text';
import SaveMessage from 'bundles/project/components/leads/show/save_message';
import { getPossibleLeadStatuses } from 'bundles/project/selectors/leads';

const SAVE_STATUS_MESSAGE_TIMEOUT = 3000;

export class LeadStatusSelect extends React.Component {
  static propTypes = {
    ariaLabel: PropTypes.string,
    lead: PropTypes.shape({
      status: PropTypes.number
    }).isRequired,
    leadStatuses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    selectComponent: PropTypes.elementType,
    onSave: PropTypes.func.isRequired,
    onSaveMessage: PropTypes.func
  };

  static defaultProps = {
    selectComponent: Select
  };

  state = {
    saving: false,
    status: this.props.lead.status
  };

  componentDidUpdate(prevProps) {
    const { lead } = this.props;
    if (prevProps.lead.status !== lead.status) {
      // Ensure state reflects latest status in DB
      this.setState({ status: lead.status });
    }
  }

  clearMessage = () => this.setState({ message: undefined });
  debouncedClearMessage = debounce(this.clearMessage, SAVE_STATUS_MESSAGE_TIMEOUT);

  handleSaveComplete = (newMessage) => {
    if (this.props.onSaveMessage) {
      this.props.onSaveMessage(newMessage);
      return;
    }

    this.setState({ message: newMessage });
    this.debouncedClearMessage();
  };

  handleSave = ({ id: selectedStatusId }) => {
    const { lead, onSave } = this.props;

    this.setState({ status: selectedStatusId, message: undefined });
    onSave(lead, { projectsLeadStatusId: selectedStatusId }).then(() => {
      this.handleSaveComplete({ type: 'success', text: 'Successfully saved' });
    }).catch((errors) => {
      const text = this.props.onSaveMessage ? saveErrorText(errors) : SAVE_ERROR_TEXT;
      this.setState({ status: this.props.lead.status });
      this.handleSaveComplete({ type: 'error', text });
    });
  };

  render() {
    const { ariaLabel, leadStatuses, selectComponent: SelectComponent } = this.props;
    return (
      <React.Fragment>
        <SelectComponent
          aria-label={ariaLabel}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.id}
          isClearable={false}
          name="lead-status-select"
          options={leadStatuses}
          value={leadStatuses.find(status => status.id === this.state.status)}
          onChange={this.handleSave}
        />
        <SaveMessage className="top-buffer-sm" message={this.state.message} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  leadStatuses: getPossibleLeadStatuses(state)
});

const mapDispatchToProps = {
  onSave: updateLeadFields
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadStatusSelect);
